import MicrosoftFileViewer from "./MicrosoftFileViewer";
export default MicrosoftFileViewer;
